// extracted by mini-css-extract-plugin
export var tosLink = "_bq-0";